import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TicketsPage } from "@/features/tickets/TicketsPage";

const search = z.object({
  queue: z.enum(["all", "mine", "not-replied"]).optional(),
});

export const Route = createFileRoute("/_app/tickets/")({
  validateSearch: search,
  component: () => <TicketsPage search={Route.useSearch()} />,
});
